import { Injectable } from '@angular/core';
import { UserService } from '../user/user.service';

@Injectable()
export class SidebarService {

  menu:any[] = [];

  constructor(public _userService:UserService) {}

  getMenu(){
    this.menu = this._userService.menu;
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/Documentos/Angular/14-AdminPro/src/app/services/sidebar/sidebar.service.ts